(() => {
  "use strict";

  const stickyOffset = () => (window.matchMedia("(max-width: 760px)").matches ? 74 : 92);

  function revealPath(pathName, options = {}) {
    const { scroll = true } = options;
    const buttons = [...document.querySelectorAll("[data-path]")];
    const panels = [...document.querySelectorAll(".task-path")];
    const activePanel = document.getElementById(`path-${pathName}`);
    if (!activePanel) return;

    buttons.forEach((button) => {
      const selected = button.dataset.path === pathName;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-expanded", String(selected));
    });
    panels.forEach((panel) => { panel.hidden = panel !== activePanel; });

    if (scroll) {
      const top = activePanel.getBoundingClientRect().top + window.scrollY - stickyOffset();
      window.scrollTo({ top, behavior: "smooth" });
      window.setTimeout(() => activePanel.focus({ preventScroll: true }), 350);
    }
  }

  document.querySelectorAll("[data-path]").forEach((button) => {
    button.addEventListener("click", () => revealPath(button.dataset.path));
  });

  const osTabs = [...document.querySelectorAll("[data-os]")];
  const osPanels = [...document.querySelectorAll(".os-panel")];
  function selectOs(osName, focus = false) {
    osTabs.forEach((tab) => {
      const selected = tab.dataset.os === osName;
      tab.setAttribute("aria-selected", String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });
    osPanels.forEach((panel) => { panel.hidden = panel.id !== `${osName}-steps`; });
  }
  osTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => selectOs(tab.dataset.os));
    tab.addEventListener("keydown", (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'ArrowLeft') next = (index - 1 + osTabs.length) % osTabs.length;
      if (event.key === 'ArrowRight') next = (index + 1) % osTabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = osTabs.length - 1;
      selectOs(osTabs[next].dataset.os, true);
    });
  });

  const setupLightbox = document.getElementById("setupImageLightbox");
  const setupLightboxImage = setupLightbox?.querySelector("img");
  const setupLightboxStage = setupLightbox?.querySelector(".setup-lightbox-stage");
  const setupLightboxCaption = document.getElementById("setupLightboxCaption");
  const setupLightboxClose = setupLightbox?.querySelector(".setup-lightbox-close");
  let setupLightboxTrigger = null;

  function closeSetupLightbox() {
    if (!setupLightbox?.open) return;
    setupLightbox.close();
  }

  document.querySelectorAll("[data-lightbox-src]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!setupLightbox || !setupLightboxImage) return;
      setupLightboxTrigger = button;
      setupLightboxImage.src = button.dataset.lightboxSrc;
      setupLightboxImage.alt = button.dataset.lightboxAlt || "Enlarged setup screenshot";
      if (setupLightboxStage) setupLightboxStage.dataset.annotation = button.dataset.annotation || "";
      if (setupLightboxCaption) setupLightboxCaption.textContent = button.dataset.lightboxCaption || "";
      document.documentElement.classList.add("setup-lightbox-open");
      setupLightbox.showModal();
      window.setTimeout(() => setupLightboxClose?.focus(), 20);
    });
  });
  setupLightboxClose?.addEventListener("click", closeSetupLightbox);
  setupLightbox?.addEventListener("click", (event) => {
    if (event.target === setupLightbox) closeSetupLightbox();
  });
  setupLightbox?.addEventListener("close", () => {
    document.documentElement.classList.remove("setup-lightbox-open");
    setupLightboxTrigger?.focus();
  });

  document.querySelectorAll(".step-next").forEach((link) => {
    link.addEventListener("click", (event) => {
      const selector = link.getAttribute("href");
      const target = selector?.startsWith("#") ? document.querySelector(selector) : null;
      if (!target) return;
      event.preventDefault();
      window.history.pushState(null, "", selector);
      const top = target.getBoundingClientRect().top + window.scrollY - stickyOffset();
      window.scrollTo({ top, behavior: "smooth" });
      window.setTimeout(() => target.focus({ preventScroll: true }), 350);
    });
  });

  document.querySelectorAll("[data-open-path]").forEach((link) => {
    link.addEventListener("click", () => revealPath(link.dataset.openPath, { scroll: false }));
  });
})();

// Optional AuraCaption Kit setup; does not alter the phone setup path.
(() => {
  'use strict';
  const kit = document.getElementById('computer-captions');
  if (!kit) return;
  function revealKit() {
    kit.open = true;
    requestAnimationFrame(() => {
      kit.scrollIntoView({block:'start', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      kit.querySelector('summary').focus({preventScroll:true});
    });
  }
  document.querySelectorAll('a[href="#computer-captions"]').forEach(link => {
    link.addEventListener('click', () => { window.setTimeout(revealKit, 0); });
  });
  if (location.hash === '#computer-captions') revealKit();
  window.addEventListener('hashchange', () => { if (location.hash === '#computer-captions') revealKit(); });
  const screen = document.getElementById('auraCaptionBlackScreen');
  const start = document.getElementById('auraCaptionFullscreen');
  const exit = document.getElementById('auraCaptionExitFullscreen');
  const status = document.getElementById('auraCaptionFullscreenStatus');
  if (!screen || !start || !exit) return;
  start.addEventListener('click', async () => {
    status.textContent = '';
    if (!screen.requestFullscreen) { status.textContent = 'Full screen is unavailable in this browser. Use a supported desktop browser.'; return; }
    screen.classList.add('is-active');
    try { await screen.requestFullscreen(); exit.focus(); }
    catch { screen.classList.remove('is-active'); status.textContent = 'Full screen could not open. Use the normal browser window, or try a supported desktop browser.'; start.focus(); }
  });
  exit.addEventListener('click', () => { if (document.fullscreenElement === screen) document.exitFullscreen(); });
  document.addEventListener('fullscreenchange', () => {
    if (document.fullscreenElement !== screen && screen.classList.contains('is-active')) { screen.classList.remove('is-active'); start.focus({preventScroll:true}); }
  });
})();

(() => {
  const root=document.getElementById('computer-captions');
  if(!root) return;
  const tabs=[...root.querySelectorAll('[data-caption-os]')];
  const panels=[...root.querySelectorAll('[data-caption-panel]')];
  function select(tab,focus=false){tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});panels.forEach(p=>{p.hidden=p.dataset.captionPanel!==tab.dataset.captionOs;});if(focus)tab.focus();}
  tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();select(tabs[e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+1)%tabs.length],true);});});
})();

// Hand off the venue-display link from phone to caption computer.
(() => {
  const section=document.getElementById('caption-display');
  const kit=document.getElementById('computer-captions');
  const copy=document.getElementById('auraCaptionCopyLink');
  const field=document.getElementById('auraCaptionGuideLink');
  const status=document.getElementById('auraCaptionCopyStatus');
  if(!section||!kit||!copy||!field||!status)return;
  function revealDisplay(){
    if(location.hash!=='#caption-display')return;
    kit.open=true;
    requestAnimationFrame(()=>{section.scrollIntoView({block:'start',behavior:'auto'});section.focus({preventScroll:true});});
  }
  window.addEventListener('hashchange',revealDisplay);
  revealDisplay();
  copy.addEventListener('click',async()=>{
    const url=location.origin+location.pathname+'#caption-display';
    field.value=url;
    try{
      if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(url);
      field.hidden=true;
      status.textContent='Link copied. Open it on your caption computer.';
    }catch{
      field.hidden=false;
      field.focus();field.select();
      status.textContent='Copy this link and open it on your caption computer.';
    }
  });
})();
